import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { Link } from "react-router-dom";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

interface BlogPost {
    id: number;
    title: string;
    summary: string;
    content: string;
    created_at: string;
}

const Blog = () => {
    const [posts, setPosts] = useState<BlogPost[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchPosts();
    }, []);

    const fetchPosts = async () => {
        try {
            const { data, error } = await supabase
                .from('blogs')
                .select('*')
                .order('created_at', { ascending: false });

            if (error) throw error;
            setPosts(data || []);
        } catch (error) {
            console.error("Hata:", error);
        } finally {
            setLoading(false);
        }
    };

    if (loading) return <div className="text-center pt-20">Yükleniyor...</div>;

    return (
        <div className="min-h-screen bg-background pt-40 pb-16">
            <div className="container mx-auto px-4">
                <h1 className="text-4xl font-bold text-center mb-12">Blog & Rehberlik</h1>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                    {posts.map((post) => (
                        <Card key={post.id} className="hover:shadow-lg transition-shadow">
                            <CardHeader>
                                <div className="text-sm text-muted-foreground mb-2">
                                    {new Date(post.created_at).toLocaleDateString('tr-TR')}
                                </div>
                                <CardTitle className="text-xl">{post.title}</CardTitle>
                            </CardHeader>
                            <CardContent>
                                <p className="text-brand-primary/70 line-clamp-3 mb-4">{post.summary}</p>
                                <Link
                                    to={`/blog/${post.id}`} // Artık doğru adrese (yazının ID'sine) gidiyor
                                    className="text-primary font-semibold text-sm hover:underline transition-all"
                                >
                                    Okumaya Devam Et
                                </Link>
                            </CardContent>
                        </Card>
                    ))}
                </div>

                {posts.length === 0 && (
                    <div className="text-center text-gray-500">Henüz blog yazısı bulunmuyor.</div>
                )}
            </div>
        </div>
    );
};

export default Blog;